import React from "react";
import { NavbarCMS, TableAboutTeam } from "../../components";
import { useSelector } from "react-redux";

const OurTeamCMS = () => {
    const setting = useSelector((state) => state?.combineReducer?.settings);
    return (
        <div className="h-full w-full">
            <NavbarCMS module={setting?.about_team?.navbar} />
            <TableAboutTeam />
        </div>
    )
}

export default OurTeamCMS;